import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './PaymentSuccess.css';

function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [clientData, setClientData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClientData = async () => {
      const clientId = searchParams.get('client_id');

      if (!clientId) {
        setLoading(false);
        return;
      }

      try {
        // Attendre quelques secondes pour que le webhook Stripe soit traité
        await new Promise(resolve => setTimeout(resolve, 3000));

        const token = localStorage.getItem('adminToken'); // Token temporaire si nécessaire
        const response = await axios.get(`/api/clients/${clientId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        setClientData(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des données:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchClientData();
  }, [searchParams]);

  return (
    <div className="payment-success-container">
      <div className="success-card">
        <div className="success-icon">✓</div>
        <h1>Paiement réussi !</h1>
        <p className="success-message">
          Votre paiement a été traité avec succès. Bienvenue chez E-Shops !
        </p>

        {loading ? (
          <div className="loading-info">
            <div className="spinner"></div>
            <p>Création de votre compte en cours...</p>
          </div>
        ) : (
          <div className="account-info">
            <h2>Vos identifiants de connexion</h2>
            <p className="info-text">
              Un email contenant vos identifiants vous a été envoyé. Vous pouvez également les noter ci-dessous :
            </p>

            <div className="credentials-box">
              <div className="credential-item">
                <label>Identifiant :</label>
                <span className="credential-value">{clientData?.client_login || 'En cours de génération...'}</span>
              </div>
              <div className="credential-item">
                <label>Mot de passe :</label>
                <span className="credential-value">{clientData?.client_password || 'En cours de génération...'}</span>
              </div>
            </div>

            <p className="warning-text">
              ⚠️ Conservez ces identifiants en lieu sûr. Vous pouvez modifier votre mot de passe après la première connexion.
            </p>

            <button
              onClick={() => navigate('/login')}
              className="btn-go-login"
            >
              Se connecter maintenant
            </button>
          </div>
        )}

        <div className="next-steps">
          <h3>Prochaines étapes</h3>
          <ol>
            <li>Connectez-vous avec vos identifiants</li>
            <li>Consultez votre espace client personnalisé</li>
            <li>Notre équipe vous contactera dans les 24h pour démarrer votre projet</li>
          </ol>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;
